export const parseQueryParameters = objectParameters => new URLSearchParams(objectParameters).toString()

export const getQueryParameter = (search, key) => new URLSearchParams(search).get(key)
